import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Contact, ProfileContact } from 'src/app/modules/admin/profile-management/profile-detail.model';
import { NbToastrService } from '@nebular/theme';
import { UserService } from 'src/app/modules/admin/user-management/user.service';
import { SettingService } from './setting.service';
import { UserModel } from 'src/app/modules/admin/user-management/user-model';
import { CallRequiredModel } from './call.service';
import { Helper } from '../utility/Helper';
@Injectable({
	providedIn: 'root'
})
export class CallflowService {

	profileUrl = environment.apiProfileManagement;

	constructor(
		private http: HttpClient,
		private settingService: SettingService,
		private userService: UserService,

	) { }

	getFinalUrl(finalUrl: string, userPhone: string) {
		let newUrl = finalUrl;
		if (!finalUrl.includes('userPhone')) {
			newUrl += userPhone && userPhone !== '' ? `&phoneNumber=${userPhone}` : '';
		}
		return newUrl;
	}


	makeACall(url, profile, type, userName, profileId: string = null) {
		return this.http.post<any>(`${this.profileUrl}/MakeACallWithCallFlow`, { url, profile, type, userName, profileId });
	}

	async makeACallWithCallFlow(contact: Contact, alternativeContactList: ProfileContact[], userId: string, pid: string, isLoading: boolean = false, toastService: NbToastrService = null, isCalling: boolean = false, entity: string = 'profile') {
		// Get All Prefix Data:
		isLoading = true;
		let requiredResult = await this.getCallRequired(userId);
		let { callerDomain, currentLoginUser } = requiredResult
		// get user phone number:
		let userPhone = window.sessionStorage.getItem('phonenumber') ?? '';
		if (userPhone === '') {
			if (contact.contactPhone && contact.contactPhone !== '') {
				userPhone += contact.contactPhone;
			} else if (contact.cellPhone && contact.cellPhone !== '') {
				userPhone += contact.cellPhone;
			} else if (contact.secondaryPhone && contact.secondaryPhone !== '') {
				userPhone += contact.secondaryPhone;
			} else if (alternativeContactList && alternativeContactList.length > 0) {
				const subContact = alternativeContactList[0];
				if (subContact.contact) {
					// subContact
					if (subContact.contact.contactPhone && subContact.contact.contactPhone !== '') {
						userPhone += subContact.contact.contactPhone;
					} else if (subContact.contact.cellPhone && subContact.contact.cellPhone !== '') {
						userPhone += subContact.contact.cellPhone;
					} else if (subContact.contact.secondaryPhone && subContact.contact.secondaryPhone !== '') {
						userPhone += subContact.contact.secondaryPhone;
					}
				}
			}
		}

		// after check user phone:
		if (!userPhone || userPhone === '') {
			if (toastService) {
				toastService.danger('This profile has no phone number, please set profile phone number.', 'Error');
			}
			if (isLoading) {
				isLoading = false;
			}
			return;
		}

		isLoading = true;
		const finalUrl = `${callerDomain}`;
		let outBoundCallUrl = this.getFinalUrl(finalUrl, Helper.trimUserPhoneNumber(userPhone));

		// add pid to caller id:
		if (!outBoundCallUrl.includes('pid')) {
			outBoundCallUrl += `&pid=${pid}`;
		}

		outBoundCallUrl += `&username=${currentLoginUser.userName}&userid=${currentLoginUser.id}`;
		
		if (!isCalling) {
			isCalling = true;
			this.makeACall(outBoundCallUrl, null, 'Call', currentLoginUser.userName, pid).pipe().subscribe(resp => {
				toastService.success('Requested a phone call', 'Success');
				isLoading = false;
				isCalling = false;
			});
		}
	}

	private async getCallRequired(userId: string) {
		let result: CallRequiredModel;
		// get domain call setting
		let domain: string;
		let callerDomainResult = this.settingService.getSettingByKeyAndGroup("DIALER_URL", "DOMAIN").toPromise();
		const dialer = (await Promise.all([callerDomainResult]))[0];
		if (dialer.result) {
			const domainResult = dialer.result.value;
			if (domainResult.includes('?')) {
				domain = dialer.result.value;
			} else {
				domain = `${dialer.result.value}?`;
			}
		}
		// get current user:
		let user: UserModel;
		let userPromise = this.userService.getUserById(userId).toPromise();
		let userResult = (await Promise.all([userPromise]))[0];
		if (userResult.result) {
			user = userResult.result;
		}

		// return data:
		result = {
			callerDomain: domain,
			currentLoginUser: user
		}
		return result;
	}
}
